import App from '@/App.vue';
import Vue from 'vue';
import router from '@/lib/router';
import store from '@/lib/store';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueI18n from 'vue-i18n';
import moment from 'moment';

Vue.config.productionTip = false;

// Vuetify
Vue.use(Vuetify);

// I18n
Vue.use(VueI18n);
const currentLocale = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : 'en';
const messages = {
    // tslint:disable-next-line: no-var-requires
    en: require('@/i18n/en.json'),
    // tslint:disable-next-line: no-var-requires
    nl: require('@/i18n/nl.json')
};
export const i18n = new VueI18n({
    locale: currentLocale,
    messages,
});

/**
 * Default date formatter. Usage: {{dateString | formatDate("MM/DD/YYYY")}}
 * If no format is added, the default format is used: MM/DD/YYYY hh:mm
 * A fallback value can be added that will be returned when the value is null/undefined/empty
 */
Vue.filter('formatDate', (value: string, format?: string, fallbackValue?: string) => {
    if (value) {
        return moment(value).format(format ? format : "MM/DD/YYYY hh:mm");
    }
    return fallbackValue;
});

/**
 * Global functions
 */
Vue.mixin({
    methods: {
        userHasAuth(authorities: string) {
            // Check if the user has the given role
            return (
                this.$store.getters.getUser &&
                this.$store.getters.getUser.authorities &&
                this.$store.getters.getUser.authorities.some((r: string) => authorities.includes(r))
            );
        }
    }
});

new Vue({
    store,
    router,
    vuetify: new Vuetify({
        icons: {
            iconfont: 'mdi',
        },
        theme: {
            dark: true,
            themes: {
                dark: {
                    primary: "#f15c22",
                    accent: "#f15c22",
                }
            }
        },
        lang: {
            t: (key, ...params) => i18n.t(key, params) as string,
        },
    }),
    i18n,
    render: (h) => h(App),
}).$mount('#app');
